// @ts-ignore
import React from "react";
import { AlertCircle } from "react-feather";
import ReactMarkdown, { type Components } from "react-markdown";
import { IconButton } from "@narmi/design_system";

const NEW_TAB_LINK_COMPONENTS: Components = {
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ),
};

const NegativeMessage = ({
  text,
  dismissMessage,
  fromQueryParam = false,
  openLinksInNewTab = false,
}: {
  text: string;
  dismissMessage: () => void;
  fromQueryParam?: boolean;
  openLinksInNewTab?: boolean;
}) => (
  <div className="message-content negative">
    <AlertCircle color="var(--color-errorDark)" />
    <span className="margin--right--l" data-testid="notification-negative" role="alert">
      {fromQueryParam ? (
        text
      ) : (
        <ReactMarkdown components={openLinksInNewTab ? NEW_TAB_LINK_COMPONENTS : undefined}>
          {text}
        </ReactMarkdown>
      )}
    </span>
    <IconButton label="Dismiss" kind="plain" name="x" size="xl" onClick={dismissMessage} />
  </div>
);

export default NegativeMessage;
